<template>
  <label>
    <input type="checkbox" @change="toggle($event)">
    <span>
    </span>

  </label>
</template>

<script>
export default {
name: "MyCheckBox",
  methods:{
    toggle(e){
      this.$emit('toggler', e.target.checked)
    }
  }
}
</script>

<style scoped>

label{
  position: absolute;
  top: calc(50% - 30px);
  right: -80px;
}

label input{
  appearance: none;
  display: none;
}

label span{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: var(--bg);
  border-radius: 40px;
  box-shadow:  var(--card-shadow);
  transition: all .3s ease-in-out;
}

input:active:checked ~ span{
  box-shadow:var(--shadow);
}

input:active ~ span{
  box-shadow:var(--card-shadow);
}

input:checked ~ span{
  box-shadow:var(--shadow);
}
</style>